var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProjects(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    clipRule: "evenodd",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.5,
    viewBox: "0 0 855 939",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 855,
    height: 939
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 855,
    height: 939
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    stroke: "#00ff85",
    strokeWidth: "12.42px"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m339.9 319.4c0-21.942-17.814-39.756-39.756-39.756h-181.39c-21.942 0-39.756 17.814-39.756 39.756s17.814 39.757 39.756 39.757h181.39c21.942-0 39.756-17.815 39.756-39.757z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m454 433.5c-0-21.942-17.814-39.757-39.756-39.757h-181.39c-21.942 0-39.757 17.815-39.757 39.757s17.815 39.756 39.757 39.756h181.39c21.942-0 39.756-17.814 39.756-39.756z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m359.06 775.16c-0-21.942-17.815-39.756-39.757-39.756h-181.39c-21.942-0-39.756 17.814-39.756 39.756s17.814 39.756 39.756 39.756h181.39c21.942 0 39.757-17.814 39.757-39.756z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1128 775.16c-0-26.492-21.508-48-48-48h-219c-26.492-0-48 21.508-48 48s21.508 48 48 48h219c26.492-0 48-21.508 48-48z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1024.8 651.93c-0-26.492-21.508-48-48-48h-219c-26.492-0-48 21.508-48 48s21.508 48 48 48h219c26.492-0 48-21.508 48-48z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m754.03 433.5c0-21.942-17.814-39.757-39.756-39.757h-181.39c-21.942 0-39.756 17.815-39.756 39.757s17.814 39.756 39.756 39.756h181.39c21.942-0 39.756-17.814 39.756-39.756z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m634.86 321.16c-0-21.942-17.815-39.756-39.757-39.756h-181.39c-21.942-0-39.756 17.814-39.756 39.756s17.814 39.756 39.756 39.756h181.39c21.942 0 39.757-17.814 39.757-39.756z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m531.46 213.4c0-21.942-17.814-39.757-39.756-39.757h-181.39c-21.942 0-39.756 17.815-39.756 39.757s17.814 39.756 39.756 39.756h181.39c21.942 0 39.756-17.814 39.756-39.756z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m828.01 213.4c0-21.942-17.814-39.757-39.756-39.757h-181.39c-21.942 0-39.756 17.815-39.756 39.757s17.814 39.756 39.756 39.756h181.39c21.942 0 39.756-17.814 39.756-39.756z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m560 539.49c0-21.942-17.814-39.756-39.756-39.756h-181.39c-21.942-0-39.756 17.814-39.756 39.756s17.814 39.756 39.756 39.756h181.39c21.942 0 39.756-17.814 39.756-39.756z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m857.7 539.49c-0-21.942-17.814-39.756-39.756-39.756h-181.39c-21.942-0-39.757 17.814-39.757 39.756s17.815 39.756 39.757 39.756h181.39c21.942 0 39.756-17.814 39.756-39.756z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m776.04 775.54c-0-21.943-17.814-39.757-39.757-39.757h-181.39c-21.943 0-39.757 17.814-39.757 39.757 0 21.942 17.814 39.756 39.757 39.756h181.39c21.943-0 39.757-17.814 39.757-39.756z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m889.1 888.6c0-21.942-17.814-39.756-39.756-39.756h-181.39c-21.942-0-39.756 17.814-39.756 39.756s17.814 39.757 39.756 39.757h181.39c21.942-0 39.756-17.815 39.756-39.757z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m934 319.4c0-21.942-17.814-39.756-39.756-39.756h-181.39c-21.942 0-39.756 17.814-39.756 39.756s17.814 39.757 39.756 39.757h181.39c21.942-0 39.756-17.815 39.756-39.757z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjects);
export default __webpack_public_path__ + "static/media/projects.f13740cfb0583aa05f3b34004a587859.svg";
export { ForwardRef as ReactComponent };